import { createForOfIteratorHelper as _createForOfIteratorHelper } from './_virtual/_rollupPluginBabelHelpers.mjs';

/** @tossdocs-ignore */
function uniqBy(arr, hasher) {
  var result = [];
  var addedElements = new Set();

  var _iterator = _createForOfIteratorHelper(arr),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      var hash = hasher(item);

      if (addedElements.has(hash)) {
        continue;
      }

      addedElements.add(hash);
      result.push(item);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
}

export { uniqBy };
